import { REACT_APP_VOICE_AGENT_URL } from "../../../../constants/Configs"
import { API_REQUEST } from "../../../../constants/General"
import { Actions } from "../../../../redux/actions"
import API from "../../../../services/api"
import { setSelectedService } from "../../../../services/middleware"
import { dispatch } from "../../../../utils/store"
import { handleError, handleSuccess } from "../../../../utils/toast"
import { restaurantDTO } from "../dtos/restaurant"

export const getAgentDetails = (id) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.get, `${REACT_APP_VOICE_AGENT_URL}/agent/${id}`)
    .then(res => {
      dispatch(Actions.RestaurantAdmin.SetRestaurantAgent, res?.data?.data)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const addAIAgent = (data, setEditable, id) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.post, `${REACT_APP_VOICE_AGENT_URL}/agents`, data)
    .then(res => {
      handleSuccess(res)
      dispatch(Actions.RestaurantAdmin.SetRestaurantAgent, res?.data?.data)
      getAgentDetails(data.restaurantId)
      setEditable(false)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}


export const setInitialValues = (restaurant) => {
  return {
    name: restaurant?.name,
    addressLine1: restaurant?.addressLine1,
    addressLine2: restaurant?.addressLine2,
    phone: restaurant?.phone,
    email: restaurant?.email,
    serviceThrough: setSelectedService(restaurant?.serviceThrough),
    tableCount: restaurant?.tableCount,
    logo: restaurant?.logo,
  }
}